module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100%",
      "overflow-y": "hidden"
    }
  }, [_c('div', {
    staticStyle: {
      "padding": "20px"
    }
  }, [_c('van-button', {
    attrs: {
      "type": "danger",
      "round": "",
      "size": "large"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.flashLogin($event)
      }
    }
  }, [_vm._v("免注册一键登录")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "10px"
    }
  }, [(!_vm.is_dengbao) ? _c('p', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink.replace",
      value: ({
        name: 'loginByUsername'
      }),
      expression: "{name:'loginByUsername'}",
      modifiers: {
        "replace": true
      }
    }],
    staticClass: "fl link"
  }, [_vm._v("账号密码登录")]) : _vm._e(), _vm._v(" "), _c('p', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink.replace",
      value: ({
        name: 'loginBySms'
      }),
      expression: "{name:'loginBySms'}",
      modifiers: {
        "replace": true
      }
    }],
    staticClass: "link fr"
  }, [_vm._v("短信快捷登录")])]), _vm._v(" "), _c('div', {
    staticClass: "cert-status login-success",
    style: ({
      top: _vm.success ? '0px' : '1000px'
    })
  }, [_c('div', {
    staticClass: "cert-status-content"
  }, [_c('div', {
    staticClass: "cert-status-icon-success"
  }), _vm._v(" "), _c('p', {
    staticClass: "cert-status-title"
  }, [_vm._v(_vm._s(_vm.phone))]), _vm._v(" "), _c('p', {
    staticClass: "cert-status-title"
  }, [_vm._v("登陆成功")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c656ccf","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/index/login.vue
// module id = 2293
// module chunks = 0